import { createFileRoute } from '@tanstack/react-router';
import { LotteryEmbedPage } from '../features/games/LotteryEmbedPage.js';

export const Route = createFileRoute('/_player/lottery/tickets')({
  component: LotteryTicketsRoute,
});

function LotteryTicketsRoute() {
  return <LotteryEmbedPage view={{ kind: 'tickets' }} />;
}
